import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useGetHomeQuery } from "@/store/rest_api";

const MailingAddressNotice: React.FC = () => {
  const { data: user } = useGetHomeQuery();
  const organisation = user?.activeOrganisation;
  const hasAddress = Boolean(
    organisation?.mailingAddressLine1?.trim() &&
      organisation?.mailingCity?.trim() &&
      organisation?.mailingState?.trim(),
  );

  if (!organisation || hasAddress) {
    return null;
  }

  return (
    <div className="status-pill-warning flex items-start gap-2 rounded-md px-3 py-2 text-xs">
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>
        Marketing email has to carry your postal address by law, so these emails will not be sent until you add a
        mailing address in{" "}
        <Link to="/manage-organisation/settings" className="underline">
          organisation settings
        </Link>
        .
      </span>
    </div>
  );
};

export default MailingAddressNotice;
